import { IllusBerry, IllusFlower, IllusSprout } from './assets';

// ────────────────────────────────────────────────────────────────────────────────

export function getRewardIllustration(index: number) {
  const illustrations = [IllusBerry, IllusFlower, IllusSprout];

  return illustrations[Math.abs(index % illustrations.length)];
}
